module.exports = __webpack_public_path__ + "img/code.f6a52558.png";